<div class="content-wrapper-inner relative">
  <app-disabled-section-widget></app-disabled-section-widget>
  <div class="page-content">
    <div class="table-topbar mb-20">
      <div class="search-holder">
        <input placeholder="Search by sender ID" type="search" class="form-control table-search" [formControl]="searchControl" />
        <span class="icon-search"></span>
      </div>
      <div class="table-action-holder">
        <div class="import me-20 cp" (click)="onClickImport()">
          <a><span class="icon-import"></span></a>
        </div>
        <div class="create">
          <a (click)="onClickContentTemplateCreate()" class="btn btn-primary py-10 px-15"><span class="icon-add"></span>Create content template</a>
        </div>
      </div>
    </div>
    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-content-template-table (actions)="templateAction($event)" (changeBatch)="selectedRows = $event"></app-content-template-table>
      <!-- The table on batch select has an action menu shown … -->
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{selectedRows.length}} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div class="text-icon-holder" (click)="onBatchDelete()">
            <span class="icon">
              <span class="far fa-trash-alt"></span>
            </span>
            <span class="text">Delete</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #createContentTemplateModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Create Content Template</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-content-template-create (onAfterSave)="afterSave($event)"></app-content-template-create>
  </div>
</ng-template>

<ng-template #editContentTemplateModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Edit Content Template</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-content-template-update (onAfterSave)="afterSave($event)"></app-content-template-update>
  </div>
</ng-template>

<ng-template #importModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Import content templates from file</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!importLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <app-content-template-import [parent]="'content-templates-table'" [backendErrors]="backendImportErrors" [fileList]="importTemplatesFileList"
      (import)="onImportContentTemplates($event)"></app-content-template-import>
  </div>
</ng-template>
